/**
 * avatarInitials — the shared "two-letter avatar" rule Figma uses across
 * Outreach (CreatorProfileDrawer's header avatar, BulkSendConfirmation's
 * recipient chips): first + last word's initial for a multi-word name
 * ("Arjun Kumar Singh" → "AS"), a single initial for a one-word
 * name/username. Two independently-written copies of this drifted (first
 * two words vs. first+last) before being consolidated here — one function,
 * so every avatar renders the same initials for the same creator.
 */
export function avatarInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const letters = words.length > 1 ? [words[0], words[words.length - 1]] : words;
  return letters
    .map((word) => word?.[0] ?? '')
    .join('')
    .toUpperCase();
}
